import React, { Fragment, useEffect, useState } from "react";
import NavBar from "./components/NavBar";
import Login from "./Login";
import Logout from "./Logout";
import CreateBill from "./CreateBill";
import Blank from "./Blank";
import Account from "./Account";
import Permission from "./Permission";
import RptBill from "./RptBill";
import RptInvoice from "./RptInvoice";
import RptDelivery from "./RptDelivery";
import RptRepository from "./RptRepository";
import RptUsage from "./RptUsage";
import Confirm from "./Confirm";
import Toolbar from "@mui/material/Toolbar";
import PrintDelivery from "./print/Delivery";
import PrintUsage from "./print/Usage";
import Bill from "./Bill";
import Excel from "./components/Excel";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { fetchData, getPermissionByToken } from "./js/main";

const noNavBarPage = [
  "/login",
  "/logout",
  "/print/delivery",
  "/print/usage",
  "/excel",
];
const onLoginPage = ["/login"];
const menuTopic = [
  { label: "Action", id: 10 },
  { label: "Report", id: 20 },
  { label: "Setting", id: 30 },
];

const pageRoutes = [
  {
    path: "/",
    component: CreateBill,
    label: "Create Bill",
    icon: "receipt",
    childOf: 10,
  },
  {
    path: "/blank",
    component: Blank,
    label: "Blank",
    icon: "receipt",
  },
  {
    path: "/bill/:bill_id",
    component: Bill,
    label: "Bill",
    icon: "receipt",
  },
  {
    path: "/bill/replace/:bill_no",
    component: CreateBill,
    label: "Create Bill",
    icon: "receipt",
  },
  {
    path: "/confirm/:invoice_id",
    component: Confirm,
    label: "Comfirm Payment",
    icon: "thumb_up_off_alt",
  },
  {
    path: "/report/invoice",
    component: RptInvoice,
    label: "Invoice List",
    icon: "monetization_on",
    childOf: 20,
  },
  {
    path: "/report/bill",
    component: RptBill,
    label: "Bill List",
    icon: "local_atm",
    childOf: 20,
  },
  {
    path: "/report/delivery",
    component: RptDelivery,
    label: "Delivery Form",
    icon: "forward_to_inbox",
    childOf: 20,
  },
  {
    path: "/report/repository",
    component: RptRepository,
    label: "Bill Archive",
    icon: "inventory",
    childOf: 20,
  },
  {
    path: "/report/usage",
    component: RptUsage,
    label: "Receipt Usage",
    icon: "receipt_long",
    childOf: 20,
  },
  {
    path: "/account",
    component: Account,
    label: "Account Chart",
    icon: "add_card",
    childOf: 30,
  },
  {
    path: "/permission",
    component: Permission,
    label: "Permission",
    icon: "verified_user",
    childOf: 30,
  },
];
const fixRoutes = [
  {
    path: "/logout",
    component: Logout,
    label: "Sign Out",
    icon: "logout",
    reload: true,
    childOf: 30,
  },
  {
    path: "/login",
    component: Login,
    reload: true,
  },
  {
    path: "/print/delivery",
    component: PrintDelivery,
  },
  {
    path: "/print/usage",
    component: PrintUsage,
  },
  {
    path: "/excel",
    component: Excel,
  },
];

function checkNoLoginPage() {
  let url = window.location.href;
  let r = false;
  for (let path of onLoginPage) {
    if (url.indexOf(path) > -1) {
      r = true;
      break;
    }
  }
  return r;
}

function App() {
  const [profile, setProfile] = useState();
  const [userMenus, setUserMenus] = useState();
  useEffect(() => {
    (async () => {
      let noLogin = checkNoLoginPage();
      if (noLogin !== true) {
        let profile = await getPermissionByToken();
        if (profile) setProfile(profile);
      } else setUserMenus(fixRoutes);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (profile) {
        let menus = await fetchData("get", "/v3/permission/menu");
        let userMenus = fixRoutes;
        for (let r of pageRoutes) {
          let i = menus.findIndex((j) => j.path === r.path);
          if (i > -1) {
            userMenus.unshift(r);
          }
        }
        setUserMenus(userMenus);
      }
    })();
  }, [profile]);

  function checkNoNavBar() {
    let url = window.location.href;
    let r = true;
    for (let path of noNavBarPage) {
      if (url.indexOf(path) > -1) {
        r = false;
        break;
      }
    }
    return r;
  }
  return (
    <div>
      <BrowserRouter>
        {profile && userMenus && checkNoNavBar() && (
          <>
            <NavBar menus={userMenus} menuTopic={menuTopic} />
            <Toolbar />
          </>
        )}
        {userMenus && (
          <Routes>
            {userMenus
              .filter((j) => j.component)
              .map((page, key) => (
                <Fragment key={key}>
                  {page.path === "/permission" ? (
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}${page.path}`}
                      element={
                        <page.component
                          page={page}
                          profile={profile}
                          pageRoutes={pageRoutes}
                          menuGroup={menuTopic}
                        />
                      }
                    />
                  ) : (
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}${page.path}`}
                      element={<page.component page={page} profile={profile} />}
                    />
                  )}
                </Fragment>
              ))}
          </Routes>
        )}
      </BrowserRouter>
      <iframe
        name="printFrame"
        title="printFrame"
        id="printFrame"
        style={{ width: "0px", height: "0px", border: "none" }}
      ></iframe>
    </div>
  );
}

export default App;
